import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {
  AdclMenuItem,
  AdclTheme,
  AdclThemingService,
  AdclUserMenuClick,
  AdclUserMenuLegal,
  AdclUserMenuProfile,
  AdclUserMenuSection,
  MainNavigationComponent,
  UserMenuComponent,
  UserMenuItemComponent,
} from '@adcl/ngx-material';
import { filter, map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { ErrorHandlerComponent } from './error-handler/error-handler.component';
import { PendoService } from './services/pendo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MainNavigationComponent,
    RouterOutlet,
    UserMenuComponent,
    UserMenuItemComponent,
    LoadingIndicatorComponent,
    ErrorHandlerComponent,
  ],
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly themeService = inject(AdclThemingService);
  selectedTheme = toSignal(this.themeService.currentTheme$);
  userMenuProfile: AdclUserMenuProfile = { name: 'Naomi Nagata', email: 'naomi.nagata@protogen.com' };
  userMenuLogout: AdclUserMenuSection = { name: 'Logout' };
  userMenuPrivacy: AdclUserMenuLegal = { name: 'Privacy' };
  userMenuTOS: AdclUserMenuLegal = {
    name: 'Terms of Service',
    url: 'https://www.aareon.de/hubfs/Aareon%20-%20Documentencenter/mareon/Final_001_Aareon_Mareon_Datenschutzhinweis_202602.pdf',
  };

  hasMainNavigation = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.url !== '/start' && e.url !== '/')
    )
  );

  productIcon = computed(() => {
    return 'mareon-logo';
  });

  menuItems = signal<AdclMenuItem[]>([]);

  constructor() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    const pendoService = inject(PendoService);

    iconRegistry.addSvgIconSet(sanitizer.bypassSecurityTrustResourceUrl('assets/icons.svg'));
    iconRegistry.addSvgIcon('mareon-logo', sanitizer.bypassSecurityTrustResourceUrl('/assets/mareon_logo.svg'));
    iconRegistry.addSvgIcon('hello', sanitizer.bypassSecurityTrustResourceUrl('/assets/illustration_hello.svg'));
    iconRegistry.addSvgIcon('mail', sanitizer.bypassSecurityTrustResourceUrl('/assets/illustration_mail.svg'));
    iconRegistry.addSvgIcon('approval', sanitizer.bypassSecurityTrustResourceUrl('/assets/illustration_approval.svg'));

    effect(() => {
      const theme = this.selectedTheme();
      if (theme) {
        document.querySelector('link[rel="icon"]')?.setAttribute('href', 'favicon.ico');
      }
    });
    //Nur erstmal Light - damit OS Einstellungen ignoriert werden und immer das Light Theme verwendet wird
    this.themeService.changeThemeTo(AdclTheme.Light);
    pendoService.initPendo();
  }

  itemClicked($event: AdclMenuItem) {
    console.log('click', $event);
  }

  userMenuSectionClicked($event: AdclUserMenuClick) {
    console.log('Section in the user menu was clicked: ', $event);
  }

  selectTheme(theme: AdclTheme) {
    this.themeService.changeThemeTo(theme);
  }
}
